import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom/list',
    method: 'get',
    params: data
  })
}

export function changeStatusItem(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom/update-status',
    method: 'put',
    data: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom/detail',
    method: 'get',
    params: data
  })
}

export function create(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom/create',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom/update',
    method: 'put',
    data: data
  })
}

export function getMasterUomList() {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom/common-list',
    method: 'get'
  })
}






// WEBPACK FOOTER //
// ./src/api/master_uom.js